import { Card, CardBody, Col } from 'reactstrap'
import { ValidationsForms } from '../../../../../Utils/Constants'
import { formValidationSchema, validationFormInitialValue, validationFormSubTitle } from '../../../../../Data/Forms/FormsControl/FormsValidation/FormsValidation'
import { useState } from 'react'
import { Formik } from 'formik'
import { FormValidationProp } from '../../../../../Types/Forms/FormsControl/FormValidation'
import FormValidations from './ValidationsForm'
import CardHeaderCommon from '../../../../../Utils/CommonComponents/CardHeaderCommon'

const ValidationForm = () => {
  const [submitErrors, setSubmitError] = useState<boolean>(false);

  const handleSubmit = (values: FormValidationProp, { resetForm }: { resetForm: () => void }) => {
    resetForm();
    setSubmitError(false);
  };

  return (
    <Col xl="6">
      <Card className="height-equal">
        <CardHeaderCommon title={ValidationsForms} span={validationFormSubTitle} />
        <CardBody>
          <Formik initialValues={validationFormInitialValue} onSubmit={handleSubmit} validationSchema={formValidationSchema}>
            {({ errors }) => <FormValidations submitErrors={submitErrors} setSubmitError={setSubmitError} errors={errors} />}
          </Formik>
        </CardBody>
      </Card>
    </Col>
  );
}

export default ValidationForm